export default __webpack_public_path__ + "static/media/delete.4726b59f.svg";